// extracted by mini-css-extract-plugin
export default {"h2":"DashBoard_h2__qJwA-","container":"DashBoard_container__UOEsd","chart":"DashBoard_chart__-KfKD","main":"DashBoard_main__-AcVy","body":"DashBoard_body__VESHQ"};